import { gql } from "apollo-boost";

export const GetOAuthLink = gql`
  query GetOAuthLink {
    linkedInOAuthUrl
  }
`;
